import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icon } from '../Icon';
import { useToggle } from 'react-use';
const styles = {
    success: {
        icon: 'check-circle',
        color: 'text-secondary',
        bgColor: 'bg-secondary-100'
    },
    info: {
        icon: 'info',
        color: 'text-blue',
        bgColor: 'bg-blue-100'
    },
    warning: {
        icon: 'error-outline',
        color: 'text-yellow',
        bgColor: 'bg-yellow-100'
    },
    error: {
        icon: 'error',
        color: 'text-red',
        bgColor: 'bg-red-100'
    },
    plain: {
        icon: 'info',
        color: 'text-gray-400',
        bgColor: 'bg-white'
    }
};
export const Alert = ({ type, children, colorableBackground, onClose, dataTestId, className }) => {
    const [hidden, toggleAlert] = useToggle(false);
    const [closeTransition, setCloseTransition] = useToggle(false);
    const iconClassName = classNames('flex-none', styles[type].color);
    const divClassName = classNames('flex text-mBase items-center min-w-min rounded-xl p-4 text-gray-700 md:text-base transition-all duration-300', colorableBackground ? styles[type].bgColor : 'bg-white shadow', type === 'plain' ? 'gap-2' : 'gap-3', { 'opacity-0': closeTransition }, { hidden }, { 'border border-black/10': colorableBackground && type === 'plain' }, className);
    const closeButtonClassName = 'self-start ml-auto';
    const closeIconClassName = 'text-gray';
    const closeAlert = async () => {
        try {
            await onClose?.();
            setCloseTransition(true);
            setTimeout(() => {
                toggleAlert();
            }, 500);
        }
        catch (error) {
            throw error;
        }
    };
    return (_jsxs("div", { className: divClassName, children: [_jsx(Icon, { className: iconClassName, "data-testid": dataTestId, name: styles[type].icon }), _jsx("span", { children: children }), onClose && (_jsx("button", { className: closeButtonClassName, type: "button", onClick: closeAlert, children: _jsx(Icon, { className: closeIconClassName, name: "close" }) }))] }));
};
